export const blockIconsPlacesCheckroom = (
	<span className='material-symbols-outlined'>checkroom</span>
);
